import React, { useState } from "react";
import { ShowMoreWrapper } from "../PrimaryTable/components/tableActions/ShowMore";

type ExpandableContentProps = {
	columnData: string;
	columnDataLength: number;
	onHoverColumnDataLength: number;
	minWidth: string;
	notShortenedClasses: string;
};

const ExpandableCellContent: React.FC<ExpandableContentProps> = ({
	columnData,
	columnDataLength,
	onHoverColumnDataLength,
	minWidth,
	notShortenedClasses,
}) => {
	const [isExpanded, setIsExpanded] = useState<boolean>(false);

	if (columnData !== null && columnData.length > columnDataLength) {
		return (
			<ShowMoreWrapper
				isExpanded={isExpanded}
				onToggle={() => setIsExpanded(!isExpanded)}
				needsExpansion={true}
				className={`${
					!isExpanded
						? "flex items-center justify-between font-omnes-regular "
						: "flex flex-col items-start h-auto"
				} ${minWidth}`}
			>
				<div
					className={`font-omnes-regular text-sm text-left text-wrap break-words ${
						!isExpanded ? "pt-0" : "pt-3 pb-3"
					} w-full`}
				>
					{!isExpanded
						? `${columnData.substring(0, columnDataLength)}...`
						: columnData}
				</div>
			</ShowMoreWrapper>
		);
	}

	return <div className={notShortenedClasses}>{columnData}</div>;
};

export default ExpandableCellContent;
